import React from 'react';

export default () => (
  <div className="Footer">
    <div className="Footer_top">
      <div className="Footer_top-links">
        <a
          href="https://merchforall.com/pages/sizes/"
          target="_blank"
          rel="noreferrer"
          className="Footer_top-link"
        >
          Sizes and Fit
        </a>
        |
        <a
          href="https://merchforall.com/pages/shipping-and-returns/"
          target="_blank"
          rel="noreferrer"
          className="Footer_top-link"
        >
          Shipping & Returns
        </a>
        |
        <a
          href="https://merchforall.com/contact/"
          target="_blank"
          rel="noreferrer"
          className="Footer_top-link"
        >
          Contact Us
        </a>
      </div>
      <svg width="220" height="51" viewBox="0 0 220 51" fill="none">
        <rect width="220" height="51" fill="url(#pattern0)" />
        <defs>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use xlinkHref="#image0" transform="scale(0.00454545 0.0196078)" />
          </pattern>
          <image
            id="image0"
            width="220"
            height="51"
            xlinkHref="data:image/png;base64,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"
          />
        </defs>
      </svg>
    </div>
    <div className="Footer_bottom">
      <span>© {new Date().getFullYear()} Merch for All LLC - All Rights Reserved</span>|
      <a
        href="https://merchforall.com/legal/privacy/"
        target="_blank"
        rel="noreferrer"
        className="Footer_bottom-link"
      >
        Privacy Policy
      </a>
      |
      <a
        href="https://merchforall.com/legal/terms/"
        target="_blank"
        rel="noreferrer"
        className="Footer_bottom-link"
      >
        Terms of Service
      </a>
    </div>
  </div>
);
